import { en } from './en'
import { es } from './es'
import type { Copy } from './types'

export type { Copy } from './types'
export type {
  AccentLine,
  ComparisonCopy,
  HighlightCopy,
  LegalDoc,
  LegalSection,
  NavLink,
  ScheduleDayCopy,
  ServiceCategoryCopy,
  ServiceRowCopy,
  StatCopy,
  TestimonialCopy,
} from './types'

export const copy: Record<'es' | 'en', Copy> = {
  es,
  en,
}
